<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmGroup"
      :title="this.$lang.Weeks.TitleForm"
      :showHelp="true"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-2">
          <label for="txtWeeksName"><small class="text-danger">*</small> {{$lang.Weeks.LabelName}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtWeeksName"
                          :placeholder="$lang.Weeks.PlaceholderEnterName"
                          v-model="form.name.value"
                          :maxlength="form.name.maxlength"
                          :required="form.name.required"
                          :state="form.name.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtWeeksName"><small class="text-danger">*</small> Ano:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtWeeksName"
                          :placeholder="'Digite o Ano'"
                          v-model="form.year.value"
                          :maxlength="form.year.maxlength"
                          :required="form.year.required"
                          :state="form.year.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtGroup"><small class="text-danger">*</small> Mês:</label>
          <div class="input-group">
            <b-form-select v-model="form.month.value" :options="form.month.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtWeeksName"><small class="text-danger">*</small> Início:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtWeeksName"
                          :placeholder="'____/____/______'"
                          v-model="form.weekControl.value"
                          :maxlength="form.weekControl.maxlength"
                          :required="form.weekControl.required"
                          :state="form.weekControl.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtWeeksName"><small class="text-danger">*</small> Fim:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtWeeksName"
                          :placeholder="'____/____/______'"
                          v-model="form.weekControl.value"
                          :maxlength="form.weekControl.maxlength"
                          :required="form.weekControl.required"
                          :state="form.weekControl.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtWeeksName"><small class="text-danger">*</small> Controle:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtWeeksName"
                          :placeholder="'Digite o controle'"
                          v-model="form.weekControl.value"
                          :maxlength="form.weekControl.maxlength"
                          :required="form.weekControl.required"
                          :state="form.weekControl.state"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <label for="txtDescription"> {{$lang.Weeks.LabelDescription}}:</label>
          <b-form-textarea id="txtDescription"
                      name="txtDescription"
                      v-model="form.description.value"
                      :placeholder="$lang.Weeks.PlaceholderEnterDescription"
                      :rows="form.description.rows"
                      :maxlength="form.description.maxlength"
                      :noResize="form.description.noResize"></b-form-textarea>
          <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
        </div>
      </div>
    </Forms>
    <Tables ref="tableGrid"
      :columns="[
        'Ano',
        'Mês',
        $lang.Weeks.DataTable.Name,
        'Início',
        'Fim',
        $lang.Common.DataTable.Status,
        $lang.Common.DataTable.ActionDate,
        $lang.Common.DataTable.AccountAction,
        $lang.Common.DataTable.Actions]"
        :showSearch="false"
        :showPrint="false"
        :showDownload="false"
        :showFullscreen="false"
        v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.name" />
        <TableColumn :IsStatus="true" v-on:Edit="onEdit(obj)" :status="obj.status" />
        <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dateUpdate" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.accountUserNameUpdate" />
        <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
      </tr>
    </Tables>
  </div>
</template>

<script>
import Weeks from './weeks.js'

export default Weeks
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/weeks/weeks.vue